/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { fields, factoryT } from 'factory-t';
import { UiType, UserRole } from '../auth/authClient.typings';
import { DetailedUserDto, UserStatus } from './usersClient.typings';

export const detailedUserFactory = factoryT<DetailedUserDto>({
    id: (ctx) => ctx.index,
    status: fields.sequence([UserStatus.Active, UserStatus.Active, UserStatus.Inactive]),
    firstName: fields.sequence(['Ivan', 'Peter', 'Philip', 'Eugen', 'Andrey', 'Sergey']),
    middleName: fields.sequence(['Philipovich', null, 'Robertovich', 'Victorovich', null, null]),
    lastName: (ctx) => 'Ivanov' + ctx.index.toString(),
    registrationAtUtc: '2020-02-02T11:27:11.996063',
    deactivationDate: fields.sequence([null, '2021-02-02T11:27:11.996063']),
    email: (ctx) => `jps${ctx.index}@noogadev.com`,
    phone: fields.sequence([null, '+375 29 675-22-99']),
    uiType: fields.sequence([UiType.Inspector, UiType.CentralInspector, UiType.RegionInspector, UiType.Operator]),
    roles: fields.sequence([
        [UserRole.Director, UserRole.Expert],
        [UserRole.Admin],
        [UserRole.Admin, UserRole.Auditor],
        [UserRole.Admin],
        [UserRole.Operator],
    ]),
    operatorName: fields.sequence(['', null, null, 'NBA INTERNATİONAL']), // for operators
    taxAuthorityId: fields.sequence(['23', '24', '25', null]), // for inspectors
    department: fields.sequence(['IT-1', 'IT-2', 'IT-3', null]), // for inspectors
    avisName: fields.sequence(['Name_1', 'Name_2', 'Name_3', null]), // for inspectors
});
